import React from 'react'
import GAAlbumDetailsContainer from '../../modules/GAAlbums/containers/GAAlbumDetailsContainer/GAAlbumDetailsContainer'

const GAAlbumDetails = () => {
  return (
    <GAAlbumDetailsContainer />
  )
}

export default GAAlbumDetails